import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { focusableClassName } from '../helpers/spatialFocus';
import { classNames } from '../lib/classNames';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  children: ReactNode;
}

export const Button = ({
  active = false,
  children,
  className,
  type = 'button',
  ...props
}: ButtonProps) => (
  <button
    type={type}
    className={classNames(
      'interactive-button',
      focusableClassName,
      active && 'interactive-button-active',
      className,
    )}
    {...props}
  >
    {children}
  </button>
);
